<template>
  <button class="vehicle-information-toggler" @click="toggleValue({ 'key': 'isVehicleInformationOpen' })">
    <oie-use-svg svg="circle-information" class="vehicle-information-toggler__svg"></oie-use-svg>
    {{ tStatic('vehicleInformationTogglerLabel') }}
  </button>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('ui', ['toggleValue'])
  }
}
</script>

<style lang="scss" scoped>
.vehicle-information-toggler {
  @include reset-button;
  @include body-smaller;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
  }
}

.section-block__header .vehicle-information-toggler {
  margin-top: measure(quarter);
  margin-left: 0;

  @include media(medium) {
    margin-top: 0;
    margin-left: measure(half);
  }
}

.vehicle-information-toggler__svg {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: measure(quarter);
}
</style>
